import React from 'react';
import styles from './SalesSummaryModal.module.css'; // Agora usa seu próprio arquivo de estilo

const SalesSummaryModal = ({ isOpen, onClose, salesData }) => {
  if (!isOpen) return null;

  // Componente auxiliar para renderizar uma lista de itens
  const renderItemsList = (items, title) => (
    <div className={styles.itemsSection}>
      <h4>{title} ({items.reduce((acc, [, qty]) => acc + qty, 0)})</h4>
      {items.length > 0 ? (
        <ul className={styles.itemsList}>
          {items.map(([product, quantity]) => (
            <li key={product}>
              <span>{product}</span>
              <strong>{quantity}x</strong>
            </li>
          ))}
        </ul>
      ) : (
        <p>Nenhum item.</p>
      )}
    </div>
  );

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h2>Resumo de Vendas do Dia</h2>
        <div className={styles.summaryContainer}>
          <span>Total de vendas registradas:</span>
          <span className={styles.summaryCount}>{salesData.count}</span>
        </div>

        <div className={styles.itemsGrid}>
          {renderItemsList(salesData.pendingItems, 'Itens a Entregar/Preparar')}
          {renderItemsList(salesData.completedItems, 'Itens Finalizados/Entregues')}
        </div>

        <div className={styles.modalActions}>
          <button onClick={onClose}>
            Fechar
          </button>
        </div>
      </div>
    </div>
  );
};

export default SalesSummaryModal;